import { sprintf } from 'sprintf-js';
import { apiInstance } from 'api/utils';

const URLS = {
  CHECK_RESET_TOKEN: '/auth/password/reset/check/%s/',
  BRIEFING: '/products/briefings/%s/',
};

export default {
  checkPasswordResetToken: (token: string) =>
    apiInstance.request({
      method: 'GET',
      url: sprintf(URLS.CHECK_RESET_TOKEN, token),
    }),
};
